import React from "react";
import ARV from "../images/auburn-road.svg";
import HT from "../images/happy-tails.svg";
import Haddon from "../images/haddon.svg";
import PG from "../images/papergreats.svg";
import NTS from "../images/night-to-shine.svg";
import M2 from "../images/m2.svg";
import WHE from "../images/whole-hearted-eating.svg";
import PB from "../images/pablo-batista.svg";

const CustomerLogos = ({ className }) => {
    const logos = [
      { src: ARV, name: "Auburn Road Vineyards" },
      { src: HT, name: "Happy Tails" },
      { src: Haddon, name: "Haddon" },
      { src: PG, name: "Paper Greats" },
      { src: NTS, name: "Night to Shine" },
      { src: M2, name: "M2" },
      { src: WHE, name: "Whole Hearted Eating" },
      { src: PB, name: "Pablo Batista" },
    ];
    // Duplicate the list for seamless marquee looping.
    const loop = [...logos, ...logos];

    return (
      <section className={["customer-logos", className].filter(Boolean).join(" ")}>
        <div className="container">
          <div className="customer-logos__header">
            <h2 className="customer-logos__title">Brands that trust us</h2>
            <p className="customer-logos__subtitle">
              Partners we’ve supported across branding, web, and creative.
            </p>
          </div>
        </div>

        <div className="customer-logos__marquee" aria-label="Customer logos">
          <div className="customer-logos__track">
            {loop.map((logo, index) => (
              <div className="customer-logos__item" key={`${logo.name}-${index}`}>
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="customer-logos__logo"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
};

export default CustomerLogos;
